<template>
  <div class="account flex-full">
    <div class="account-inner">

      <!-- Navigation -->
      <nav class="account-menu">
        <router-link
          class="account-menu-item no-underline relative"
          :class="{ active: $route.path === page.link || orderPage && page.link === '/my-account/orders' }"
          v-for="(page, index) in navigation"
          :key="index"
          :to="localizedRoute(page.link)"
          @click="notify(page.title)"
        >
          {{ $t(page.title) }}
          <div class="waring-icon" v-if="dangerImage(page.link)">
            <span v-if="dangerImage(page.link) === 'warning'" class="material-icons">error_outline</span>
            <span class="number-orders" v-else-if="dangerImage(page.link) === 'warningCounter'">{{ currentUser.unpaid_orders }}</span>
          </div>
        </router-link>
      </nav>
      <!---->

      <!-- Content -->
      <div class="account-content" :class="{'full': isFullPageContent}">
        <no-ssr>
          <keep-alive>
            <component :is="this.$props.activeBlock" />
          </keep-alive>
        </no-ssr>
        <bounce-loader style="margin-bottom: 40px" v-if="loader" />
      </div>
      <!---->

    </div>
  </div>
</template>

<script async>
import MyAccount from '@vue-storefront/core/pages/MyAccount'
import NoSSR from 'vue-no-ssr'
import { mapActions, mapGetters } from 'vuex'

const BounceLoader = () => import(/* webpackChunkName: "vsf-bounce-loader" */ 'theme/components/theme/blocks/Home/Preloaders/BounceLoader');
const MyRecentlyViewed = () => import(/* webpackChunkName: "vsf-my-recently-viewer" */ '../components/core/blocks/MyAccount/MyRecentlyViewed');
const MyOrder = () => import(/* webpackChunkName: "vsf-my-order" */ '../components/core/blocks/MyAccount/MyOrder');
const MyOrders = () => import(/* webpackChunkName: "vsf-my-orders" */ '../components/core/blocks/MyAccount/MyOrders');
const MyNewsletter = () => import(/* webpackChunkName: "vsf-my-newsletter" */ '../components/core/blocks/MyAccount/MyNewsletter');
const MyPaymentDetails = () => import(/* webpackChunkName: "vsf-my-payment-details" */ '../components/core/blocks/MyAccount/MyPaymentDetails');
const MyShippingDetails = () => import(/* webpackChunkName: "vsf-my-shipping-details" */ '../components/core/blocks/MyAccount/MyShippingDetails');
const MyPassword = () => import(/* webpackChunkName: "vsf-my-password" */ '../components/core/blocks/MyAccount/MyPassword');
const MyProfile = () => import(/* webpackChunkName: "vsf-my-profile" */ '../components/core/blocks/MyAccount/MyProfile');
const Breadcrumbs = () => import(/* webpackChunkName: "vsf-breadcrumbs" */ '../components/core/Breadcrumbs');

export default {
  components: {
    Breadcrumbs,
    MyProfile,
    MyPassword,
    MyShippingDetails,
    MyPaymentDetails,
    MyNewsletter,
    MyOrders,
    MyOrder,
    MyRecentlyViewed,
    'no-ssr': NoSSR,
    BounceLoader
  },
  mixins: [MyAccount],
  data () {
    return {
      navigation: [
        { title: 'Personal information', link: '/my-account' },
        { title: 'Change password', link: '/my-account/password' },
        { title: 'Delivery address', link: '/my-account/shipping-details' },
        { title: 'My payment details', link: '/my-account/payment-details' },
        { title: 'My orders', link: '/my-account/orders' }
      ],
      background: '/assets/bg-home.png',
      partner: ''
    }
  },
  computed: {
    ...mapGetters({
      getPartnerCode: 'partners/getCurrentPartner',
      loader: 'ui/getLoader',
      addresses: 'address/getAddressList'
    }),
    ordersHistory () {
      return this.$store.state.user.orders_history
    },
    currentUser () {
      return this.$store.state.user.current
    },
    order () {
      return this.ordersHistory.find(order => {
        if (parseInt(order.id) === parseInt(this.$route.params.orderId)) {
          return order
        }
      }, (this))
    },
    orderPage () {
      return this.$route.name === 'my-order';
    },
    isFullPageContent () {
      return ['my-orders', 'my-shipping-details'].includes(this.$route.name);
    }
  },
  methods: {
    ...mapActions({
      resetState: 'partners/resetCurrentPartner',
      loadPartners: 'partners/loadPartners'
    }),
    notify (title) {
      if (title === 'My loyalty card' || title === 'My product reviews') {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'warning',
          message: this.$t('This feature is not implemented yet! Please take a look at https://github.com/DivanteLtd/vue-storefront/issues for our Roadmap!'),
          action1: { label: this.$t('OK') }
        })
      }
    },
    dangerImage (route) {
      if (this.currentUser) {
        if ((route === '/my-account' && (!this.currentUser.telephone || !this.currentUser.phone_verified)) || (route === '/my-account/shipping-details' && this.$store.state.address.addressesLoading && this.addresses && !this.addresses.length)) {
          return 'warning'
        } else if (route === '/my-account/orders' && this.currentUser.unpaid_orders) {
          return 'warningCounter'
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  .account {
    width: 100%;
    position: relative;

    display: flex;
    justify-content: center;

    &:before {
      width: 100%;
      height: 60px;

      position: absolute;
      top: 0;
      right: 0;
      left: 0;

      margin: auto;
      content: '';

      background: #f5f5f5;
      z-index: -1;

      @media only screen and (max-width: 576px) {
        height: 50px;
      }
    }

    &-inner {
      width: 1154px;

      display: flex;
      justify-content: space-between;

      @media only screen and (max-width: 1200px) {
        width: 962px;
      }

      @media only screen and (max-width: 991px) {
        width: 722px;
      }

      @media only screen and (max-width: 768px) {
        width: 560px;
      }

      @media only screen and (max-width: 576px) {
        width: 100%;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }
    }

    &-menu {
      width: 262px;

      display: flex;
      flex-direction: column;

      background-color: #f5f5f5;

      @media only screen and (max-width: 576px) {
        width: auto;
        height: 51px;

        margin-top: 0;
      }

      &-item {
        width: -webkit-fill-available;
        height: 60px;
        box-sizing: border-box;
        padding: 16px 20px 16px 60px;

        position: relative;

        color: #0f0f0f;
        font-size: 16px;
        line-height: 1.75;

        transition: .2s;

        @media only screen and (max-width: 576px) {
          width: auto;
          display: none;
          padding: 16px 0 16px 40px;
        }

        &:hover, &.active {
          cursor: pointer;
          background-color: #fff;

          &:before {
            background-color: #11bb2e;
          }

          &:nth-child(1):before {
            background-image: url('../assets/account/icon-user-active.png');
          }

          &:nth-child(2):before {
            background-image: url('../assets/account/icon-password-active.svg');
          }

          &:nth-child(3):before {
            background-image: url('../assets/account/icon-location-active.png');
          }

          &:nth-child(4):before {
            background-image: url('../assets/account/icon-purse-active.png');
          }

          &:nth-child(5):before {
            background-image: url('../assets/account/icon-order-active.png');
          }

          @media only screen and (max-width: 576px) {
            display: inline-flex;
            background-color: transparent;
            text-align: center;
          }
        }

        &:before {
          width: 26px;
          height: 26px;

          position: absolute;
          top: 0;
          left: 20px;
          bottom: 0;

          margin: auto;
          content: '';

          border-radius: 50%;
          background-color: #fff;

          background-position: center;
          background-size: 14px;
          background-repeat: no-repeat;

          transition: .2s;

          @media only screen and (max-width: 576px) {
            left: 0;
          }
        }

        &:nth-child(1):before {
          background-image: url('../assets/account/icon-user.png');
        }

        &:nth-child(2):before {
          background-image: url('../assets/account/icon-password.svg');
        }

        &:nth-child(3):before {
          background-image: url('../assets/account/icon-location.png');
        }

        &:nth-child(4):before {
          background-image: url('../assets/account/icon-purse.png');
        }

        &:nth-child(5):before {
          background-image: url('../assets/account/icon-order.png');
        }
      }
      .waring-icon {
        width: 26px;
        height: 26px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 10px;
        color: #ff0000;
        margin: auto;
        @media (max-width: 576px) {
          right: -35px;
        }
      }
      .number-orders {
        background: #ff0000;
        color: #fff;
        border-radius: 50px;
        padding: 3px 0;
        display: flex;
        max-height: -webkit-fill-available;
        align-items: center;
        justify-content: center;
      }
    }

    &-content {
      &.full {
        min-height: calc(100dvh - 60px);
      }

      width: 75%;

      margin-bottom: 20px;
      padding-left: 30px;

      @media only screen and (max-width: 1200px) {
        width: calc(962px - 262px - 30px);
      }

      @media only screen and (max-width: 991px) {
        width: calc(722px - 262px - 30px);
      }

      @media only screen and (max-width: 768px) {
        width: calc(560px - 262px - 30px);
      }

      @media only screen and (max-width: 576px) {
        width: 100%;
        flex-direction: column;
        align-items: center;
      }

      @media only screen and (max-width: 576px) {
        width: 100%;
        padding-left: 0;
      }
    }
  }
</style>
